(() => {
  const auth = window.SpeedgripAuth || {};
  const FILE_RE =
    /\.(pdf|zip|stp|step|sldprt|sldasm|sat|igs|iges|x_t|x_b|prt|asm|dxf|dwg|ipt|iam)(?:$|\?)/i;

  function currentPath() {
    return window.location.pathname + window.location.search + window.location.hash;
  }

  function toRelativePath(returnTo) {
    if (!returnTo) return currentPath();
    if (returnTo.charAt(0) === '/') return returnTo;

    try {
      const url = new URL(returnTo, window.location.origin);
      if (url.origin === window.location.origin) {
        return url.pathname + url.search + url.hash;
      }
    } catch (error) {
      // Fall through to the current page.
    }

    return currentPath();
  }

  function goToLogin(returnTo) {
    const path = toRelativePath(returnTo);
    window.location.href =
      '/customer_authentication/login?return_to=' + encodeURIComponent(path);
  }

  function findQuoteSpecsField() {
    return (
      document.querySelector('#CustomSpecifications') ||
      document.querySelector('[name="properties[Custom Specifications]"]') ||
      document.querySelector('[name="properties[Custom Specifications:]"]') ||
      document.querySelector('textarea[placeholder*="changes or special requirements"]') ||
      Array.from(document.querySelectorAll('textarea, input[type="text"]')).find((el) => {
        const haystack = [
          el.name,
          el.id,
          el.getAttribute('aria-label'),
          el.placeholder,
          el.closest('label') && el.closest('label').textContent,
        ]
          .join(' ')
          .toLowerCase();
        return (
          haystack.indexOf('custom specification') !== -1 ||
          haystack.indexOf('special requirements') !== -1
        );
      }) ||
      null
    );
  }

  function saveQuoteDraft() {
    const specsField = findQuoteSpecsField();
    const qty = document.querySelector('input[name="quantity"]');
    try {
      sessionStorage.setItem(
        'sgPendingQuote',
        JSON.stringify({
          path: window.location.pathname,
          specs: specsField ? (specsField.value || '').trim() : '',
          qty: qty ? qty.value : '',
        })
      );
    } catch (error) {
      // Ignore storage failures and still send the guest to login.
    }
  }

  function gateDownload(fileUrl) {
    if (fileUrl) {
      try {
        sessionStorage.setItem('sgPendingDownload', fileUrl);
      } catch (error) {
        // Ignore storage failures and still send the guest to login.
      }
    }
    goToLogin(currentPath());
    return false;
  }

  function isFileUrl(href) {
    if (!href || href === '#' || href.toLowerCase().indexOf('javascript:') === 0) {
      return false;
    }

    try {
      const url = new URL(href, window.location.origin);
      if (FILE_RE.test(url.pathname)) return true;
      if (/catalog\.speedgrip\.com\/files\//i.test(url.href)) return true;
      return false;
    } catch (error) {
      return FILE_RE.test(href);
    }
  }

  function isDownloadTrigger(el) {
    if (!el || !el.closest) return null;

    const trigger = el.closest('a[href], [data-brochure-download], [download]');
    if (!trigger) return null;

    const href = trigger.getAttribute('href') || '';
    if (
      trigger.hasAttribute('download') ||
      trigger.hasAttribute('data-brochure-download') ||
      trigger.closest('[data-brochure-download]') ||
      isFileUrl(href)
    ) {
      return trigger;
    }

    return null;
  }

  function isCheckoutControl(el) {
    if (!el || !el.closest) return false;

    const control = el.closest(
      'button, a, [data-checkout-button], [data-action="checkout"], .shopify-payment-button, .additional-checkout-buttons'
    );
    if (!control) return false;

    if (
      control.matches(
        'button[name="checkout"], [name="checkout"], [data-checkout-button], [data-action="checkout"], a[href*="/checkout"], .cart__checkout-button'
      )
    ) {
      return true;
    }

    if (control.closest('.cart__dynamic-checkout-buttons, .additional-checkout-buttons, .shopify-payment-button')) {
      return true;
    }

    return false;
  }

  function resumePendingDownload() {
    let url = '';
    try {
      url = sessionStorage.getItem('sgPendingDownload') || '';
      sessionStorage.removeItem('sgPendingDownload');
    } catch (error) {
      return;
    }
    if (!url) return;

    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = '';
    anchor.rel = 'noopener';
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
  }

  function restorePendingQuote() {
    let data = null;
    try {
      const raw = sessionStorage.getItem('sgPendingQuote');
      if (!raw) return;
      data = JSON.parse(raw);
      sessionStorage.removeItem('sgPendingQuote');
    } catch (error) {
      return;
    }

    if (!data || (data.path && data.path !== window.location.pathname)) return;

    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      const specs = findQuoteSpecsField();
      const qty = document.querySelector('input[name="quantity"]');

      if (specs && data.specs) {
        specs.value = data.specs;
        specs.dispatchEvent(new Event('input', { bubbles: true }));
        specs.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (qty && data.qty) {
        qty.value = data.qty;
        qty.dispatchEvent(new Event('input', { bubbles: true }));
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (specs || tries > 40) clearInterval(timer);
    }, 250);
  }

  auth.goToLogin = goToLogin;
  auth.gateDownload = gateDownload;
  window.SpeedgripAuth = auth;

  if (auth.loggedIn) {
    resumePendingDownload();
    restorePendingQuote();
    return;
  }

  function eventElement(event) {
    const node = event.target;
    if (!node) return null;
    return node.closest ? node : node.parentElement;
  }

  document.addEventListener(
    'click',
    (event) => {
      const from = eventElement(event);
      const quoteButton = from && from.closest && from.closest('.request-quote-button');
      if (quoteButton) {
        event.preventDefault();
        event.stopPropagation();
        saveQuoteDraft();
        goToLogin(currentPath());
        return;
      }

      const downloadTrigger = isDownloadTrigger(from);
      if (downloadTrigger) {
        event.preventDefault();
        event.stopPropagation();
        const href = downloadTrigger.getAttribute('href') || '';
        const fileUrl = href && href !== '#' ? href : downloadTrigger.getAttribute('data-brochure-url') || '';
        gateDownload(fileUrl);
        return;
      }

      if (isCheckoutControl(from)) {
        event.preventDefault();
        event.stopPropagation();
        goToLogin('/checkout');
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!form || !form.querySelector) return;
      if (!form.querySelector('[name="checkout"]')) return;
      event.preventDefault();
      goToLogin('/checkout');
    },
    true
  );
})();
